import { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

// Simple portal to render children into document.body so fixed overlays are viewport-scoped
export function Portal({ children }: PropsWithChildren<{}>) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
